module.exports = __webpack_public_path__ + "img/right-arrow-blue1.3369786f.svg";